import CautionIcon from 'app/components/icons/CautionIcon';
import Modal from 'app/components/Modal';
import React from 'react';
import style from './MetamaskErrorModal.module.scss';

const metamaskInstallationVideoUrl =
  'https://www.youtube.com/watch?v=8BL7COrxJvg';

type MetamaskErrorModalProps = {
  open?: boolean;
  onClose?: (...args: any[]) => void;
};

const MetamaskErrorModal = ({ open, onClose }: MetamaskErrorModalProps) => {
  const className = 'c-MetamaskErrorModal';

  return (
    <Modal
      open={open}
      showCloseIcon={false}
      onClose={onClose}
      customContainerClass={style[`${className}__modal`]}
    >
      <div className={style[className]}>
        <div className={style[`${className}__title`]}>
          <CautionIcon />
          Unable to connect
        </div>
        <div className={style[`${className}__body`]}>
          Please use Metamask mobile in-app browser to connect. You can watch{' '}
          <a
            href={metamaskInstallationVideoUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            this video
          </a>{' '}
          to learn more.
        </div>
        <div className={style[`${className}__cta`]} onClick={onClose}>
          Close
        </div>
      </div>
    </Modal>
  );
};

export default MetamaskErrorModal;
